import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-gpt-five-mini',
  templateUrl: './gpt-five-mini.component.html',
  styleUrls: ['./gpt-five-mini.component.scss']
})
export class GptFiveMiniComponent {
  constructor(public dialogRef: MatDialogRef<GptFiveMiniComponent>) {}

  close(): void {
    this.dialogRef.close();
  }
}
